import { render } from "./RegistrationResult.vue?vue&type=template&id=dde943f4"
import script from "./RegistrationResult.vue?vue&type=script&lang=js"
export * from "./RegistrationResult.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\Furbetta\\WebAppPrenotazionePrimaVisita\\booking-prima-visita-v3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__